document.addEventListener("DOMContentLoaded", () => {
    /*
    const swiper = new Swiper(".swiper", {
        // Optional parameters
        direction: "horizontal",
        loop: true,
        speed: 400,
        spaceBetween: 100,
        slidesPerView: 4,

        // Navigation arrows
        navigation: {
            nextEl: ".slider__control_right",
            prevEl: ".slider__control_left",
        },
    });
    */
});
